import React from 'react';
import assets from 'assets';
import { useNavigate } from 'react-router';

import styled from 'styled-components';

const GiftCard = () => {
  const navigate = useNavigate();

  const handleGiftClick = () => {
    navigate('/settings/gifts');
  };

  return (
    <Container role='link' onClick={handleGiftClick}>
      <div className='gift-image'>
        <img src={assets.giftIcon} alt='' />
      </div>
      <p className='font-size-24'>Give the gift of AI </p>
    </Container>
  );
};

export default GiftCard;

const Container = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.darkgrey};
  padding: 14px 25px;
  background-image: url(${assets.bg});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  border-radius: 15px;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;

  & p {
    color: ${({ theme }) => theme.colors.primary};
    margin: 0px;
    text-align: center;
    font-weight: 600;
  }
`;
